import React from 'react';

import Accommodations from 'components/shared/LandingPage/blocks/Accommodations';
import ContactsBlock from 'components/shared/LandingPage/blocks/Contacts';
import LocationBlock from 'components/shared/LandingPage/blocks/Location';
import SheetsBlock from 'components/shared/LandingPage/blocks/Sheets';
import { LANDING_PAGE_TYPES } from 'constants/index';

import Accordion from './Accordion';
import Costs from './Costs';
import CoverPage from './CoverPage';
import Document from './Document';
import GalleryBlock from './Gallery';
import Guests from './Guests';
import Headline from './Headline';
import { IframeBlock } from './Iframe';
import Image from './Image';
import ListBlock from './ListBlock';
import Subtitle from './Manifest/Subtitle';
import Overview from './Overview';
import OverviewMap from './OverviewMap';
import Room from './Room';
import RichText from './Text';
import TravelWallet from './TravelWallet';
import { TripEventBlock } from './TripEventBlock';
import { CheckpointsBlock } from './TripEventBlock/CheckpointsBlock';
import { MoreDetails } from './TripEventBlock/MoreDetails';
import {
  IBlockConfig,
  IGetBlockPropsParams,
  IGetBlockPropsResult,
  IGetCustomPropsParams,
  IGetCustomPropsResult,
} from './types';
import Video from './Video';

const baseBlockConfig = {
  withContentWrapper: false,
  isSticky: false,
  // getAnchorId: ({ pageIndex, sectionIndex, blockIndex }: IGetAnchorIdParams) => 'block_' + [pageIndex, sectionIndex, blockIndex].join('-'),
  Component: (props: any) => <div {...props} />,
  getCustomProps: () => ({}),
  getBlockProps: () => ({}),
};

const getConfig = (customConfig: IBlockConfig) => {
  return {
    ...baseBlockConfig,
    ...customConfig,
  };
};

// TODO need to change inside Record<string, IBlockConfig> string to enum block type, but need to prepare it first
export const BLOCKS_CONFIG: Record<string, IBlockConfig> = {
  header: getConfig({
    withContentWrapper: {
      lowerPosition: true,
    },
    isSticky: true,
    // getAnchorId: ({ data }: IGetAnchorIdParams) => removeSpaces(data.subheadline),
    Component: Headline,
    getCustomProps: ({ blockIndex }: IGetCustomPropsParams) => {
      const props: IGetCustomPropsResult = {};
      if (blockIndex === 0) {
        props.withoutTopBorder = true;
      }

      return props;
    },
    getBlockProps: ({ blockIndex, disableFirstSectionNameRemoval }: IGetBlockPropsParams) => {
      const props: IGetBlockPropsResult = {};

      if (blockIndex === 0 && disableFirstSectionNameRemoval) {
        props.hiddenTrash = true;
      }

      return props;
    },
  }),
  embed: getConfig({
    withContentWrapper: true,
    Component: Video,
  }),
  iframe: getConfig({
    withContentWrapper: true,
    Component: IframeBlock,
  }),
  list: getConfig({
    withContentWrapper: {
      hasFastFactsButton: true,
    },
    Component: ListBlock,
  }),
  image: getConfig({
    withContentWrapper: {
      hasImageButton: true,
    },
    Component: Image,
  }),
  text: getConfig({
    Component: RichText,
  }),
  accordion: getConfig({
    withContentWrapper: true,
    Component: Accordion,
  }),
  accommodations: getConfig({
    Component: Accommodations,
  }),
  location: getConfig({
    Component: LocationBlock,
  }),
  contacts: getConfig({
    Component: ContactsBlock,
  }),
  sheets: getConfig({
    Component: SheetsBlock,
  }),
  gallery: getConfig({
    Component: GalleryBlock,
  }),
  trip_event: getConfig({
    Component: TripEventBlock,
    disabledAddingBlocksForChildren: true,
  }),
  checkpoints: getConfig({
    Component: CheckpointsBlock,
  }),
  more_details: getConfig({
    Component: MoreDetails,
    disabledAddingBlocksForChildren: false,
  }),
  room: getConfig({
    Component: Room,
    disabledAddingBlocks: true,
  }),
  [LANDING_PAGE_TYPES.COVER_PAGE]: getConfig({
    Component: CoverPage,
  }),
  [LANDING_PAGE_TYPES.SAFARI_OVERVIEW]: getConfig({
    Component: Overview,
  }),
  [LANDING_PAGE_TYPES.SAFARI_MAP]: getConfig({
    Component: OverviewMap,
  }),
  [LANDING_PAGE_TYPES.SAFARI_COSTS]: getConfig({
    Component: Costs,
    getBlockProps: () =>
      ({
        readonly: true,
      }) as IGetBlockPropsResult,
  }),
  [LANDING_PAGE_TYPES.RELOCATIONS]: getConfig({
    Component: () => null,
  }),
  [LANDING_PAGE_TYPES.GUESTS]: getConfig({ Component: Guests }),
  [LANDING_PAGE_TYPES.SAFARI_MANIFEST]: getConfig({
    Component: () => <Overview showDivider />,
    disabledAddingBlocks: true,
  }),
  [LANDING_PAGE_TYPES.TRAVEL_WALLET]: getConfig({ Component: TravelWallet }),
  subtitle: getConfig({
    Component: Subtitle,
    disabledAddingBlocks: true,
  }),
  document: getConfig({
    withContentWrapper: {
      hasDocumentButton: true,
    },
    Component: Document,
  }),
};
